import { render } from "./DeleteResource.vue?vue&type=template&id=57d0150e"
import script from "./DeleteResource.vue?vue&type=script&lang=js"
export * from "./DeleteResource.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__